
















































import Preloader from '~/components/other/Preloader'
import ItemList from "~/components/gallery/ItemList"
import GalleryPreview from "~/components/gallery/GalleryPreview"
import GalleryFilters from "~/components/gallery/GalleryFilters"
import Pagination from "~/components/other/Pagination"
import NotFound from "~/components/gallery/NotFound"
import MtArrowLink from '@/components/other/MtArrowLink'

export default {
  components: {
    MtArrowLink,
    ItemList,
    GalleryPreview,
    GalleryFilters,
    Pagination,
    NotFound,
    Preloader
  },
  data() {
    return {
      loading: true,
      firstOpen: !this.$route.query.hasOwnProperty('ignoreBanner')
    };
  },
  computed: {
    currentPage () {
      return this.$route.query.pageNum ? Number(this.$route.query.pageNum) : 1
    },
    getSelectedValue(type) {
      return this.$route.query.hasOwnProperty([type]) ? this.$route.query[type] : null
    },
    isEn () {
      return this.$i18n.locale === 'en'
    },
    pageText() {
      return this.isEn ? 'page' : 'страница'
    },
    fromText() {
      return this.isEn ? 'of' : 'из'
    }
  },
  watch: {
    gallery: function () {
      this.loading = true
    },
    loading: function () {
      if (Object.keys(this.$route.query).length && (Object.keys(this.$route.query).length !== 1 && this.$route.query.lang)) {
        if (typeof window !== 'undefined') {
          const target = document.querySelector('#galleryStart')
          if (target) {
            window.scrollTo(0, target.offsetTop - 100);
          }
        }
      }
      if (this.firstOpen) {
        this.firstOpen = false
      } else if (!this.loading) {
        if (typeof window !== 'undefined') {
          const target = document.querySelector('#galleryStart')
          if (target) {
            window.scrollTo(0, target.offsetTop - 100);
          }
        }
      }
    }
  },
  head() {
    const seo = this.getSeo?.data?.data || {}
    const pageCount = this.gallery?.data?.data?.pageCount || 1
    const haveQuery = Object.keys(this.$route.query).length
    let title = seo.title
    if (title) {
      title = title.replace(/&quot;/g, '"').replace(/&lsquo;/g, '‘').replace(/&laquo;/g, '«').replace(/&raquo;/g, '»')
    }
    if (pageCount > 1) {
      title += ` - ${this.pageText} ${this.$route.query.pageNum || 1} ${this.fromText} ${pageCount}`
    }
    const config = {
      title: title,
      meta: [
        { hid: 'og:title', name: 'og:title', content: title },
        { hid: 'description', name: 'description', content: seo.description },
        { hid: 'og:description', name: 'og:description', content: seo.description },
        { hid: 'keywords', name: 'keywords', content: seo.keywords }
      ]
    }
    if (haveQuery) {
      config.link = [{
        rel: 'canonical',
        href: `https://my.tretyakov.ru/app/gallery`
      }]
    }
    return config
  },
  chimera: {
    getSeo () {
      return {
        url: `/api/v1/seo/getByCode`,
        key: `page-seo-gallery`,
        params: {
          code: 'gallery',
          lang: this.$i18n.locale || 'ru'
        }
      }
    },
    gallery () {
      let config = {}
      const types = ['category', 'period', 'author', 'loyalty', 'canPatron', 'style']
      types.forEach(type => {
        if(this.$route.query.hasOwnProperty(type)) {
          let result = this.$route.query[type]
          if (type === 'loyalty') {
            result = Number(result) === 1
          }
          config[`filter[${type}]`] = result
        }
      });
      if (this.$route.query.search) {
        config['search[q]'] = this.$route.query.search
      }
      if (this.$route.query.compilation) {
        config.compilationId = this.$route.query.compilation
        this.$router.push({
          path: `/compilations/exhibitionsarchive/${config.compilationId}/`
        })
        return
      }
      config = {
        ...config,
        pageNum: this.$route.query.pageNum ? Number(this.$route.query.pageNum) : 1,
        pageSize: this.$route.query.canPatron ? 20 : 18,
        sort: this.$route.query.sort ? this.$route.query.sort : '',
        order: this.$route.query.order? this.$route.query.order : '',
        lang: this.$i18n.locale || 'ru'
      }
      return {
        url: `/api/v1/gallery/get/`,
        key: `gallery-list-${JSON.stringify(config)}`,
        auto: true,
        // method: 'post',
        params: {
          ...config,
        }
      }
    }
  }
}
